import { render, staticRenderFns } from "./TreeviewPattern.vue?vue&type=template&id=13fdd9d7&"
import script from "./TreeviewPattern.vue?vue&type=script&lang=js&"
export * from "./TreeviewPattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports